import cn from './TestEnvironmentBadge.module.scss'

export default function TestEnvironmentBadge() {
  return (
    <div className={cn.badge} role="status" aria-label="Тестовый сервер">
      <span className={cn.title}>Тестовый сервер</span>
      <span className={cn.note}>данные не настоящие</span>
    </div>
  )
}
